const NAV_LINKS = {
  tape_transfer: [
    { text: 'Tape Transfer Page', pageKey: 'tapeTransfer' },
    { text: 'VHS', pageKey: 'vhs' },
    { text: 'VHS-C', pageKey: 'vhsC' },
    { text: 'Hi-8', pageKey: 'hi8' },
    { text: 'Mini-DV', pageKey: 'miniDV' },
    { text: 'Betamax', pageKey: 'betamax' },
    { text: 'Pro Format', pageKey: 'proFormat' },
  ],
  photo_scan: [
    { text: 'Photo Scanning Page', pageKey: 'photoScan' },
    { text: 'Loose Photos', pageKey: 'loosePhotos' },
    { text: 'Slides', pageKey: 'slides' },
    { text: 'Negatives', pageKey: 'negatives' },
    { text: 'Document Scanning', pageKey: 'documentScanning' },
    { text: 'Photo Albums', pageKey: 'photoAlbums' },
  ],
  film_transfer: [
    { text: 'Film Digitizing Page', pageKey: 'filmTransfer' },
    { text: '8mm', pageKey: 'film8mm' },
    { text: 'Super 8mm', pageKey: 'filmSuper8mm' },
    { text: '16mm', pageKey: 'film16mm' },
  ],
};

export default NAV_LINKS;
